module.exports = __webpack_public_path__ + "a8886d86f7b358c396b75469812cd481.png";